import { Channel } from '@/Enums/Channel.enum';
import ForecasterDateRange from '@/Enums/Forecaster/DateRange.enum';
import { IProduct } from '@/Interfaces/Product.interface';
import moment from 'moment';
import { dateToRangeFormat, getDefaultChannelFilters } from '.';

export const getDefaultFormValues = (currentChannel: Channel, products: Partial<Record<Channel, IProduct[]>> = {}) => {
  const _currentChannel = currentChannel ?? Channel.CTV;
  return {
    forecastName: '',
    forecastId: undefined,
    tabIndex: 0,
    currentChannel: _currentChannel,
    daysInRange: ForecasterDateRange.Week,
    [Channel.CTV]: getDefaultChannelFilters(Channel.CTV),
    [Channel.OLV]: getDefaultChannelFilters(Channel.OLV),
    [Channel.Display]: getDefaultChannelFilters(Channel.Display),
    [Channel.Audio]: getDefaultChannelFilters(Channel.Audio),
    [Channel.SpotifyDirect]: getDefaultChannelFilters(Channel.SpotifyDirect),
    [Channel.Gaming]: getDefaultChannelFilters(Channel.Gaming),
    [Channel.Dooh]: getDefaultChannelFilters(Channel.Dooh),
    [Channel.Google]: getDefaultChannelFilters(Channel.Google, products?.[Channel.Google] ?? []),
    [Channel.Amazon]: getDefaultChannelFilters(Channel.Amazon),
    [Channel.GamVideo]: getDefaultChannelFilters(Channel.GamVideo),
    [Channel.GamDisplay]: getDefaultChannelFilters(Channel.GamDisplay),
    geographic: [],
    isGeoFencingSearch: false,
    frequencyCapEnabled: false,
    frequencyCapPerDay: null,
    geoFence: null,
    dateRange: dateToRangeFormat(moment(), moment().add({ days: 6 })),
    dealIds: [],
  };
};
